import { render } from "./WealthDeclaration.vue?vue&type=template&id=14e78d25&scoped=true"
import script from "./WealthDeclaration.vue?vue&type=script&lang=js"
export * from "./WealthDeclaration.vue?vue&type=script&lang=js"

import "./WealthDeclaration.vue?vue&type=style&index=0&id=14e78d25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e78d25"]])

export default __exports__